import { DefaultPanel } from '../gadgets/panel';
import { API } from '../libs/api';
import { Row } from '../gadgets/row';
import { UserInfo } from '../libs/statics';
import { Forms } from '../gadgets/forms';
import { ALERT } from '../libs/alerts';
var ProfilePage = /** @class */ (function () {
    function ProfilePage() {
    }
    ProfilePage.prototype.run = function (finish) {
        var panel = new DefaultPanel("Profil");
        var mainRow = new Row();
        var forms = new Forms();
        mainRow.addCustomGadget("<dt>Name:</dt><dd>".concat(UserInfo.firstname, " ").concat(UserInfo.surname, "</dd><dt>E-Mail:</dt><dd>").concat(UserInfo.email, "</dd><dt>Geburtstag:</dt><dd>").concat(UserInfo.birthdate, "</dd>"), 'col-xl-2');
        mainRow.addCustomGadget("<dt>Passwort \u00E4ndern</dt><dd>".concat(forms.passwordChangeFormLite('profileUserPass'), "</dd>"), 'col-xl-2');
        mainRow.addCustomGadget("", 'col-xl-4');
        // mainRow.addCustomGadget(`<span id="totp_state"></span>`, 'col-xl-4')
        panel.addGadget(mainRow);
        panel.appendToContent(function () {
            forms.onPasswordInputChange('profileUserPass');
            $('#profileUserPass_savebtn').on('click', function (e) {
                e.preventDefault();
                var newPass = $('#profileUserPass_confirm').val();
                if (newPass.length >= 6) {
                    API.updateData("profile", 0, [["password", newPass], ["force_logout", "1"]], null, function () {
                        $('#profileUserPass_password').val('');
                        $('#profileUserPass_confirm').val('');
                        $("#profileUserPass_savebtn").attr('disabled', "true");
                    });
                }
                else {
                    ALERT.showSimple("Passwort zu kurz!", "Das Passwort muss mindestens 6 Zeichen enthalten", "error");
                }
            });
            finish();
            // API.getData("profile/totp_validated", result=>{
            //     if (!result.totp_validated)
            //     {
            //         API.getData("profile/totp_info", _res => {
            //             //console.log(_res)
            //             $('#totp_state').html(`Nutzen Sie die Option zur Aktivierung der Zwei-Faktor-Authentifizierung und erhöhen Sie die Sicherheit ihres Kontos.<br><br>Scannen Sie hierzu den QR-Code mit einer Authenticator-App und geben Sie die darauf folgenden 6 Ziffern zur Bestätigung ein.<hr><div style="text-align:center"><a href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&pcampaignid=web_share" target="_blank" class="market-btn google-btn" role="button" style="margin-right:5px"><span class="market-button-subtitle">Download für Android</span><span class="market-button-title">Google Play</span></a><a href="https://apps.apple.com/de/app/google-authenticator/id388497605" target="_blank" class="market-btn apple-btn" role="button"><span class="market-button-subtitle">Download für Apple</span><span class="market-button-title">App Store</span></a></div><hr><img style="display:block; margin-left:auto; margin-right:auto" src="data:image/png;base64, ${_res.totp_info.qrcode}" />`)
            //             $('#totp_state').append(forms.totpInputs())
            //             forms.totpListenEvent(val => {
            //                 API.postData("profile/totp_validate", "validate", "", [["key", val]], msg => {
            //                     console.log(msg);
            //                     if (msg.has_data && msg.data.totp_backupkeys != undefined)
            //                     {
            //                         ALERT.showSimple("Backup Schlüssel", "Dies sind ihre Einmal-Ersatzschlüssel, kopieren und sicher aufbewahren\n\n"+msg.data.totp_backupkeys.join('\n'), "info", "Ich habe die Schlüssel gesichert.", false, () =>{
            //                             Pager.loadPage("profile")
            //                         })
            //                     }
            //                 })
            //             })
            //             finish()
            //         })
            //     } else {
            //         $('#totp_state').html(`<div style="color:darkgreen; text-align:center;">Zwei-Faktor-Authentifizierung ist aktiv!</div>`)
            //         finish()
            //     }
            // })
        });
    };
    return ProfilePage;
}());
export { ProfilePage };
